import { SAVE_PROJECT_PATH, SET_PROJECT_LIST } from '../actions/hypprojectlist';

const initialState = {
  projectList: [],
};

export default function hyperexecuteProjectList(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case SAVE_PROJECT_PATH:
      return { ...state, projectList: action.payload };
    case SET_PROJECT_LIST:
      return { ...state, projectList: action.payload };
    default:
      return { ...state };
  }
}
